<template>
  <div id="">
    <v-card class="d-print-none pa-1">
      <v-row align="center" dense>
        <v-col class="d-flex pr-0" xs="12" md="2">
          <v-select
            v-model="v1t"
            class="has-append-btn"
            height="20"
            :items="variablesTable"
            return-object
            :disabled="loading"
            single-line
            hide-details
            item-text="label"
            dense
            outlined
            tile
          >
            <template v-slot:append-outer>
              <div class="d-flex">
                <selector
                  v-model="v1t.filter.selected"
                  label="v1"
                  :title="v1t.label"
                  :item-children="v1t.itemChildren"
                  :items="v1t.filter.items"
                >
                  <template v-slot:button="{ on, selected }">
                    <v-btn
                      outlined
                      tile
                      height="40"
                      :disabled="loading"
                      v-on="on"
                    >
                      <v-badge
                        bordered
                        color="green"
                        :value="v1t.filter.selected.length"
                        :content="v1t.filter.selected.length"
                      >
                        <v-icon>mdi-filter</v-icon>
                      </v-badge>
                    </v-btn>
                  </template>
                </selector>
                <v-icon>mdi-chevron-right</v-icon>
              </div>
            </template>
          </v-select>
        </v-col>

        <v-col class="d-flex pr-0" xs="12" md="2">
          <v-select
            v-model="v2t"
            class="has-append-btn"
            :items="variablesTable"
            return-object
            :disabled="loading"
            single-line
            hide-details
            item-text="label"
            dense
            outlined
          >
            <template v-slot:append-outer>
              <div class="d-flex">
                <selector
                  v-model="v2t.filter.selected"
                  label="v2"
                  :title="v2t.label"
                  :item-children="v2t.itemChildren"
                  :items="v2t.filter.items"
                >
                  <template v-slot:button="{ on, selected }">
                    <v-btn
                      outlined
                      tile
                      height="40"
                      :disabled="loading"
                      v-on="on"
                    >
                      <v-badge
                        bordered
                        color="deep-purple"
                        :value="v2t.filter.selected.length"
                        :content="v2t.filter.selected.length"
                      >
                        <v-icon>mdi-filter</v-icon>
                      </v-badge>
                    </v-btn>
                  </template>
                </selector>
                <!-- <v-icon>mdi-chevron-right</v-icon> -->
              </div>
            </template>
          </v-select>
        </v-col>

        <!--
          <v-col class="d-flex pr-0" xs="12" md="2">
          <v-select
          v-model="v3t"
          class="has-append-btn"
          :items="variablesTableAndNull"
          return-object
          :disabled="loading"
          single-line
          hide-details
          item-text="label"
          dense
          outlined
          >
          <template v-slot:append-outer>
          <div class="d-flex">
          <selector
          v-model="v3t.filter.selected"
          label="v3"
          :title="v3t.label"
          :item-children="v3t.itemChildren"
          :items="v3t.filter.items"
          >
          <template v-slot:button="{ on, selected }">
          <v-btn
          outlined
          tile
          height="40"
          :disabled="v3t == nullItem || loading"
          v-on="on"
          >
          <v-badge
          bordered
          color="teal"
          :value="v3t.filter.selected.length"
          :content="v3t.filter.selected.length"
          >
          <v-icon>mdi-filter</v-icon>
          </v-badge>
          </v-btn>
          </template>
          </selector>
          </div>
          </template>
          </v-select>
          </v-col>
        -->

        <v-divider v-show="!isMobile" color="primary" vertical />

        <v-btn
          text
          :disabled="searchOptionList.length >= 3 || loading"
          @click="addComparison()"
          color="primary"
        >
          Comparar
          <v-icon class="ml-2">playlist_add</v-icon>
        </v-btn>

        <v-spacer />

          <!--
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              :small="isMobile"
              class="pr-xs-2 pr-lg-0"
              text
              icon
              color="primary"
              :disabled="
                loading ||
                  dataTable.data == undefined ||
                  dataTable.data.length == 0
              "
              @click="print()"
            >
              <v-icon>print</v-icon>
            </v-btn>
          </template>
          <span>Imprimir</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              :small="isMobile"
              text
              icon
              color="primary"
              :disabled="
                loading ||
                  dataTable.data == undefined ||
                  dataTable.data.length == 0
              "
              @click="downloadXls()"
            >
              <v-icon>mdi-file-excel</v-icon>
            </v-btn>
          </template>
          <span>Descargar Excel</span>
        </v-tooltip>
          -->

        

        <v-col xs="12" md="auto">
          <v-select
            v-model="campoSelected"
            style="max-width: 200px"
            outlined
            dense
            hide-details
            :disabled="loading"
            item-text="label"
            return-object
            :items="camposOptions"
            label="Campos"
          />
        </v-col>

        <v-col xs="12" lg="auto">
          <v-btn
            :disabled="verifyVarHeader()"
            color="accent"
            @click="refresh()"
          >
            Recargar
          </v-btn>
        </v-col>
      </v-row>
      <v-progress-linear
        color="accent"
        :active="loading"
        :indeterminate="loading"
        absolute
        bottom
      />
    </v-card>

    <!--  -->
    <v-sheet class="d-print-none outlined-2 pa-2">
      <div
        class="d-flex flex-row pa-1 mx-4 search-option"
        v-for="(searchOption, index) in searchOptionList"
        :key="index"
      >
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn
              v-show="!isMobile"
              text
              :disabled="loading"
              v-on="on"
              color="primary"
            >
              {{ searchOption.optionTimeSelected.label }}
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(item, index) in optionsTime"
              :key="index"
              @click="changeOptionTime(searchOption, item)"
            >
              <v-list-item-content>
                <v-list-item-title>{{ item.label }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-btn
          v-show="searchOption.optionTimeSelected.var == 'mensual'"
          text
          icon
          color="primary"
          :disabled="loading"
          @click="moveMonth(searchOption, -1)"
        >
          <v-icon>chevron_left</v-icon>
        </v-btn>

        <v-btn
          v-show="searchOption.optionTimeSelected.var == 'mensual'"
          text
          icon
          color="primary"
          :disabled="loading"
          @click="moveMonth(searchOption, 1)"
        >
          <v-icon>chevron_right</v-icon>
        </v-btn>

        <div v-show="searchOption.optionTimeSelected.var == 'mensual'">
          <v-menu
            v-model="searchOption.dateMenuMonth"
            offset-y
            :close-on-content-click="false"
            transition="scale-transition"
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                text
                color="primary"
                class="ma-0"
                :disabled="loading"
                v-on="on"
              >
                <v-icon class="mr-3" :small="isMobile">
                  today
                </v-icon>
                {{ searchOption.dates.dateMonthFormated }}
              </v-btn>
            </template>

            <v-date-picker
              v-model="searchOption.dates.dateMonth"
              color="primary"
              :disabled="loading"
              no-title
              type="month"
              locale="es-cl"
              @change="selectMonth(searchOption)"
            />
          </v-menu>
        </div>

        <div v-show="searchOption.optionTimeSelected.var == 'temporada'">
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn
                :disabled="loading"
                color="primary"
                class="d-none d-md-flex"
                text
                v-on="on"
              >
                {{ searchOption.periodoSelected.label || "periodo" }}
                <v-icon right>
                  arrow_drop_down
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(periodo,pIndex) in periodos"
                :key="'p-' + pIndex"
                @click="selectPeriodo(searchOption, periodo)"
              >
                <v-list-item-title>{{ periodo.label }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>

        <div v-show="searchOption.optionTimeSelected.var == 'fechas'">
          <v-menu
            v-model="searchOption.dateMenuIni"
            offset-y
            transition="scale-transition"
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                text
                color="primary"
                class="ma-0"
                :disabled="loading"
                v-on="on"
              >
                <v-icon class="mr-3" :small="isMobile">
                  today
                </v-icon>
                {{ searchOption.dates.dateInicioFormatedReadeable }}
              </v-btn>
            </template>

            <v-date-picker
              v-model="searchOption.dates.dateInicioFormated"
              color="primary"
              no-title
              locale="es-cl"
              @change="changeDates(searchOption)"
            />
          </v-menu>
        </div>

        <div v-show="searchOption.optionTimeSelected.var == 'fechas'">
          <v-menu
            v-model="searchOption.dateMenuFin"
            offset-y
            transition="scale-transition"
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                text
                color="primary"
                class="ma-0"
                :disabled="loading"
                v-on="on"
              >
                <v-icon class="mr-3" :small="isMobile">
                  today
                </v-icon>
                {{ searchOption.dates.dateFinFormatedReadeable }}
              </v-btn>
            </template>

            <v-date-picker
              v-model="searchOption.dates.dateFinFormated"
              color="primary"
              no-title
              locale="es-cl"
              @change="changeDates(searchOption)"
            />
          </v-menu>
        </div>

        <v-divider v-show="!isMobile" color="primary" vertical />

        <v-menu :close-on-content-click="false" :nudge-width="200" offset-y>
          <template v-slot:activator="{ on }">
            <v-btn
              v-show="!isMobile"
              text
              :disabled="loading"
              color="primary"
              v-on="on"
            >
              Filtros
            </v-btn>
          </template>

          <v-card>
            <v-container>
              <v-row align="center" no-gutters>
                <v-col cols="6">
                  <v-subheader>Dia</v-subheader>
                </v-col>

                <v-col cols="6">
                  <v-select
                    v-model="searchOption.filter.dia"
                    :items="filterOptions.diaOptions"
                    :disabled="loading"
                    item-text="label"
                    return-object
                    label="tipo tarjas"
                    single-line
                  />
                </v-col>
              </v-row>

              <v-row align="center" no-gutters>
                <v-col cols="6">
                  <v-subheader>Tipo Trabajador</v-subheader>
                </v-col>

                <v-col cols="6">
                  <v-select
                    v-model="searchOption.filter.tipoTrabajador"
                    :items="filterOptions.tipoTrabajadorOptions"
                    item-text="label"
                    :disabled="loading"
                    label="tipo trabajador"
                    return-object
                    single-line
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-menu>

        <div>
          <div v-if="searchOption.filter.dia.value > -1" class="tag">
            <span>
              {{ searchOption.filter.dia.label }}
            </span>
          </div>

          <div
            v-if="searchOption.filter.tipoTrabajador.value != 'todos'"
            class="tag"
          >
            <span>
              {{ searchOption.filter.tipoTrabajador.label }}
            </span>
          </div>
        </div>

        <v-spacer />

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              :small="isMobile"
              class="pr-xs-2 pr-lg-0"
              text
              icon
              color="primary"
              :disabled="loading || searchOptionList.length <= 1"
              @click="removeComparison(searchOption)"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </template>
          <span> Quitar comparación</span>
        </v-tooltip>
      </div>
    </v-sheet>

    <div class="d-print-flex d-none justify-space-between header-print">
      <div>
        Árbol: {{ v1t.label }} > {{ v2t.label }}
        <br />
        <span v-show="campoSelected !== null">
          Campo: {{ campoSelected.label }}
        </span>
      </div>
      <!--
      <div v-show="searchOption.optionTimeSelected.var == 'mensual'">
        Mes: {{ dateMonthFormatedPrint }}
      </div>
      <div v-show="searchOption.optionTimeSelected.var == 'temporada'">
        Temporada: {{ periodoSelected.label }}
      </div>
      <div v-show="searchOption.optionTimeSelected.var == 'fechas'">
        Desde: {{ dates.dateInicioFormatedReadeable }}
        <br />
        Hasta: {{ dates.dateFinFormatedReadeable }}
      </div>

      <div>
        <div v-if="filter.dia.value > -1" class="tag tag-print">
          <span>
            {{ filter.dia.label }}
          </span>
        </div>

        <div
          v-if="filter.tipoTrabajador.value != 'todos'"
          class="tag tag-print"
        >
          <span>
            {{ filter.tipoTrabajador.label }}
          </span>
        </div>
      </div>
      -->
    </div>

    <v-row align="center" no-gutters class="p-relative">
      <v-col class="d-flex px-6 white "
             md="2" xs="12"
           :class="{
                'p-absolute top right' : !isMobile
           }"
           style="z-index:2">
        <v-select
          v-if="chartOptions"
          v-model="varChartOptionSelected"
          @change="changeVarChartOption()"
          class="has-append-btn"
          :items="varChartOptions"
          return-object
          :disabled="loading"
          single-line
          hide-details
          item-text="name"
          dense
          outlined
          />
      </v-col>
      <v-col cols="12">
        <highcharts
          v-if="chartOptions"
          :key="'chart-' + chartKey"
          class="chart-presupuestos"
          :options="chartOptions"
          :callback="callbackChart"
        />
      </v-col>
    </v-row>

    <v-row align="center" no-gutters>
      <v-col cols="12">
        <analisis-table
          :key=" searchOptionList[0].dates.dateInicio.unix() + '_libro-remuneraciones'"
          ref="analisisComparativoTable"
          :dates=" searchOptionList[0].dates"
          :data-table="dataTable"
          :contratistas="contratistas"
          :trabajadores="trabajadores"
          @change="changeTable()"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import campoModel from "@/models/campoModel";
import trabajadorModel from "@/models/trabajadorModel";
import contratistaModel from "@/models/contratistaModel";
import centrosCostoModel from "@/models/centrosCostoModel";
import laborModel from "@/models/laborModel";
import subLaborModel from "@/models/subLaborModel";
import Repository from "@/models/repoIrricrops";
import selector from "@/components/selector";

import { Chart } from "highcharts-vue";

import HighchartsAnalisis from "@/views/AnalisisComparativoHighchartsSetDefaults";
import analisisTable from "@/views/AnalisisComparativoTable";

export default {
  name: "AnalisisComparativo",
  components: {
    highcharts: Chart,
    selector,
    analisisTable 
  },
  data: () => ({
    campos: [],
    camposOptions: [],
    campoSelected: null,
    camposMenu: false,
    loading: true,
    arrayData: [],

    searchOptionDefault: {
      dateMenuMonth: false,
      dateMenuIni: false,
      dateMenuFin: false,
      dates: {},
      optionTimeSelected: null,
      periodoSelected: null,
      filter: {
        dia: null,
        tipoTrabajador: null
      }
    },

    datesOptions: {
      dateInicio: moment().startOf("month"),
      dateFin: moment().endOf("month"),
      dateInicioFormated: moment()
        .startOf("month")
        .format("YYYY-MM-DD"),
      dateFinFormated: moment()
        .endOf("month")
        .format("YYYY-MM-DD"),
      dateInicioFormatedReadeable: moment()
        .startOf("month")
        .format("DD MMM YY"),
      dateFinFormatedReadeable: moment()
        .endOf("month")
        .format("DD MMM YY"),
      dateMonth: moment()
        .startOf("month")
        .format("YY-MM"),
      dateMonthFormated: moment()
        .startOf("month")
        .format("MMM, YYYY")
    },


     searchOptionList: [],

    trabajadores: [],
    contratistas: [],
    labores: [],
    laboresParsed: [],
    subLabores: [],
    centrosCosto: [],

    dataTable: {},
    colors: {
      colorReal: "#ff9900",
      colorPresupuesto: "#109618",
      colorComparison: "#3b3eac"
    },

    /*
    dateMenuMonth: false,
    dateMenuIni: false,
    dateMenuFin: false,
    */

    //variable: null,

    //optionTimeSelected: null,
    optionsTime: [
      { label: "Mensual", var: "mensual" },
      { label: "Temporada", var: "temporada" },
      { label: "Entre fechas", var: "fechas" }
    ],

    periodos: [
      /*
      {
        label: "2023-2024",
        init: "2023-05-01",
        end: "2024-04-30"
      },
      {
        label: "2022-2023",
        init: "2022-05-01",
        end: "2023-04-30"
      },
      */
      {
        label: "2021-2022",
        init: "2021-05-01",
        end: "2022-04-30"
      },
      {
        label: "2020-2021",
        init: "2020-05-01",
        end: "2021-04-30"
      },
      {
        label: "2019-2020",
        init: "2019-05-01",
        end: "2020-04-30"
      },
      {
        label: "2018-2019",
        init: "2018-05-01",
        end: "2019-04-30"
      },
      {
        label: "2017-2018",
        init: "2017-05-01",
        end: "2018-04-30"
      }
    ],

    //periodoSelected: null,

    //selected: [],

    //dia: true,
    //trato: false,
    //contratista: false,

    variablesTable: [
      {
        label: "Labor",
        itemChildren: "subLabores", // para vista de arbol, con nombre de hijos variables
        treeName: "labor",
        varName: ["labor", "sub_labor"],
        paramFilterName: "sub_labores_id",
        showOptionalData: [false, true], // para mostrar total, pero se activa en la tabla como cascada
        filter: { items: [], selected: [] }
      },
      {
        label: "Centro de costo",
        itemChildren: "",
        treeName: "centro_costo",
        paramFilterName: "centros_costo_id",
        varName: "centros_costo",
        showOptionalData: [false],
        filter: { items: [], selected: [] }
      }
      /*
      {
        label: "Trabajador",
        itemChildren: "",
        treeName: "trabajador",
        paramFilterName: "trabajadores_id",
        varName: "trabajador",
        showOptionalData: [false],
        filter: { items: [], selected: [] }
      }
      */
    ],

    variablesTableAndNull: null,
    nullItem: {
      label: "- No Asignado -",
      //active  : true,
      treeName: null,
      varName: null,
      filter: { items: [], selected: [] }
    },

    v1t: null,
    v2t: null,
    //v3t: null,

    filterOptions: {
      //dia: null,
      diaOptions: [
        {
          label: "Todos",
          value: -1
        },
        {
          label: "Dia",
          value: 1
        },
        {
          label: "Trato",
          value: 0
        },
        {
          label: "Dia + Trato",
          value: 2
        }
      ],

      //tipoTrabajador: null,
      tipoTrabajadorOptions: [
        {
          label: "Todos",
          value: "todos"
        },
        {
          label: "Contratista",
          value: "contratista"
        },
        {
          label: "Sin Contratistas",
          value: "sin_contratista"
        }
      ]
    },

    //chart
    varChartOptions: [
      {
        name: "Jornadas",
        varName: "jornadas"
      },
      {
        name: "Jornadas / Ha",
        varName: "jornadas_ha"
      },
      {
        name: "Rendimiento / jor",
        varName: "rendimiento_jr",
      },{

        name: "Valor dia",
        varName: "dia_jr",
      },{

        name: "Valor trato",
        varName: "valor_trato",
      }
    ],
    varChartOptionSelected: null,

    chart: null,
    chartKey: 1,
    varNameChart: "jornadas_ha",
    varNameLabel: "Jornadas / ha",

    titleChart: "Analisis",
    subtitlePath: [],

    chartOptions: null
  }),
  computed: {
    empresaSelected() {
      return this.$store.getters.empresaSelected;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    }
  },
  watch: {
    empresaSelected() {
      this.clearFilters();
      this.getBaseData();
    }
  },
  mounted() {
    this.clearFilters();
    this.getBaseData();
  },
  created() {
    HighchartsAnalisis.apply();

    this.v1t = this.variablesTable[0];
    this.v2t = this.variablesTable[1];
    //this.v3t = this.variablesTableAndNull[3];

    this.campoSelected = this.nullItem;
    this.varChartOptionSelected = _.first(this.varChartOptions);

    let initialSearchOptions = _.clone(this.searchOptionDefault);
    initialSearchOptions.optionTimeSelected = this.optionsTime[0];
    initialSearchOptions.periodoSelected = _.first(this.periodos);
    initialSearchOptions.filter.dia = _.first(this.filterOptions.diaOptions);
    initialSearchOptions.filter.tipoTrabajador = _.first(
      this.filterOptions.tipoTrabajadorOptions
    );
    initialSearchOptions.dates = _.cloneDeep(this.datesOptions);
    this.searchOptionList= [initialSearchOptions];
  },
  methods: {
    /*
    changePeriodo(periodo) {
      this.periodoSelected = periodo;
      this.refresh();
    },
    */

    async refresh() {
      this.loading = true;
      let arrayData = await this.getDataSearchList();
      this.parseData(arrayData);
      this.prepareChart(arrayData);
      this.arrayData = arrayData;
      this.loading = false;
    },

    changeTable() {
      this.refresh();
    },

    changeVarChartOption(){
      this.prepareChart(this.arrayData);
    },

    addComparison() {
      let searchOption = _.cloneDeep(_.last(this.searchOptionList));
      this.searchOptionList.push(searchOption);
    },

    removeComparison(searchOption){
      if(this.searchOptionList.length > 1){
        const index = this.searchOptionList.indexOf(searchOption);
        if (index > -1) {
          this.searchOptionList.splice(index, 1);
        }
      }
    },

    getDataSearchList() {
      let promises = this.searchOptionList.map(searchOption => {
        return this.getData(searchOption);
      });
      return Promise.all(promises);
    },

    getData(searchOption) {
      var self = this;
      var arbol = this.getFullTreeName();
      var params = {
        empresa_id: this.empresaSelected.id,
        fecha_inicio: searchOption.dates.dateInicioFormated,
        fecha_fin: searchOption.dates.dateFinFormated,
        arbol: arbol
      };

      if (searchOption.filter.tipoTrabajador.value != "todos") {
        params.tipo_trabajador = searchOption.filter.tipoTrabajador.value;
      }

      if (searchOption.filter.dia.value >= 0) {
        params.dia = searchOption.filter.dia.value;
      }

      if (this.campoSelected.val !== null) {
        params.campos_id = [this.campoSelected.val.id];
      }

      this.variablesTable.forEach(varTable => {
        if (varTable.filter.selected.length > 0) {
          params[varTable.paramFilterName] = varTable.filter.selected.map(
            s => s.id
          );
        }
      });

      return Repository.get("/presupuesto/real/", { params })
        .then(
          response => {
            /*
            self.loading = false;
            self.parseData(response.data.data);
            self.prepareChart.bind(self)(self.dataTable.data);
            self.chartKey++;
            */
            return {
              data: response.data.data,
              searchOption
            };
          },
          resError => {
            self.loading = false;
            console.error(resError);
            console.log("FAILURE!!");
          }
        )
        .catch(error => {
          console.error(error);
          console.log("error occured");
        });
    },

    parseData(arrayData) {
      var vars =  this.getTreeVarNames();

      var varShowOptionalData = _.flattenDeep([
        this.v1t.showOptionalData,
        this.v2t.showOptionalData
        //this.v3t.showOptionalData
      ]);

      var cascadeIsActive = false;

      varShowOptionalData = _.map(varShowOptionalData, v => {
        cascadeIsActive = cascadeIsActive || v;
        return cascadeIsActive;
      });

      // como mezclar resultados de otros meses?
      // considerar que podrian traer datos diferentes

      let data = this.mergeArrayData(arrayData);
      
      //TODO traspasar esto a la funcion merge
      var dataParsed = _.map(data, d => {
        d.showOptionalData = varShowOptionalData[0];
        //d.label = d.nombre;
        d.clickItem = {};
        d.clickItem[vars[0]] = d.id;

        d.children = _.map(d[vars[1]], d2 => {
          d2.showOptionalData = varShowOptionalData[1];
          //d2.label = d2.nombre;
          d2.clickItem = { ...d.clickItem };
          d2.clickItem[vars[1]] = d2.id;

          d2.children = _.map(d2[vars[2]], d3 => {
            d3.showOptionalData = varShowOptionalData[2];
            //d3.label = d3.nombre;
            d3.clickItem = { ...d2.clickItem };
            d3.clickItem[vars[2]] = d3.id;

            d3.children = _.map(d3[vars[3]], d4 => {
              d4.showOptionalData = varShowOptionalData[3];
              //d4.label = d4.nombre;
              d4.clickItem = { ...d3.clickItem };
              d4.clickItem[vars[3]] = d4.id;
              return d4;
            });
            return d3;
          });
          return d2;
        });
        return d;
      });

      this.dataTable = {
        header: this.getHeaderTable(arrayData),
        title: "_",
        data: dataParsed,
        vars: vars,
        totales: data.total || null
      };
    },

    mergeArrayData(arrayData){
      var vars =  this.getTreeVarNames();
      
      let varname = vars[0];

      //agrupa los datos segun indice del arrayData (usando so_0, so_1... )
      //para poder separar los datos, pero dentro de un arreglo mezclado

      let arrayFormated = arrayData.flatMap((item,indexItem) => {
        return (item.data[varname] || []).map(itemData => {

          let dataFormated = {
            id:itemData.id,
            label:itemData.nombre,
          }
          
          let childVarName = vars[1];
          dataFormated[childVarName] = (itemData[childVarName] || []).map(childItem => {

            let childDataFormated = {
              id: childItem.id,
              label: childItem.nombre
            }
 


          let grandChildVarName = vars[2];

          childDataFormated[grandChildVarName] = (childItem[grandChildVarName] || []).map(grandChildItem => {
            let grandChildDataFormated = {
              id: grandChildItem.id,
              label: grandChildItem.nombre
            }
            //---

            grandChildDataFormated["so_"+indexItem] = grandChildItem;
            return grandChildDataFormated;
          });




            childDataFormated["so_"+indexItem] = childItem;
            return childDataFormated;
          });


          dataFormated["so_"+indexItem] = itemData;
          return dataFormated;
        })
      });


      //reduce el array formateado, ya que los items estan repetidos por id
      //asi puede hacer la mezcla de variables
      let arrayReduced = arrayFormated.reduce((acc, item ) => {
        let itemFound = acc.find(a => a.id == item.id);
        if(itemFound){


          let childVarName = vars[1];
          let childReduced = [ ...itemFound[childVarName],  ...item[childVarName]].reduce((acc, child) => {
            let childFound = acc.find(a => a.id == child.id);
            if(childFound ){



              let grandChildVarName = vars[2];
              let grandChildReduced = [ ...childFound[grandChildVarName],  ...child[grandChildVarName]].reduce((acc, grandChild) => {
                let grandChildFound = acc.find(a => a.id == grandChild.id);
                if(grandChildFound ){
                  //--
                  _.extend(grandChildFound , grandChild);
                }else{
                  acc.push(_.cloneDeep( grandChild));
                }
                return acc;
              }, []);




              _.extend(childFound,child);
              childFound[grandChildVarName] = grandChildReduced;
            }else{
              acc.push(_.cloneDeep(child));
            }
            return acc;
          }, []);


          _.extend(itemFound, item);
          itemFound[childVarName] = childReduced;
        }else{
          acc.push(_.cloneDeep(item));
        }
        return acc;
      }, []);





      //TODO optimizar codigo, 
      //TODO hacer header consistente a datos formateados

      return arrayReduced;
    },


    getHeaderTable(arrayData){
      let baseHeaderConfig = [
        {
          label: "Jornadas Totales",
          print: false, //"Jornadas",
          mobile: "Jor",
          value: "jornadas",
          totalPrefix: "∑",
          round: 2,
          tooltip: "",
          cell_width: "xl"
        },

        {
          label: "Jornadas / ha",
          print: false, //"Jornadas/ha",
          mobile: "Jo/ha",
          value: "jornadas_ha",
          round: 2,
          totalPrefix: "X̅",
          optionalPrefix: "X̅",
          average: true,
          tooltip: "",
          cell_width:"xl"
        },

        {
          label: "Rendimiento / jor",
          print: false, //"Rend/jo",
          mobile: "Jo/ha",
          value: "rendimiento_jr",
          totalPrefix: "X̅",
          round: 2,
          tooltip: "",
          optional: true,
          cell_width:"xl"
        },

        {
          label: "Valor dia",
          print: "Valor Dia",
          mobile: "valor/dia",
          value: "dia_jr",
          round: 0,
          prefix: " $",
          totalPrefix: "X̅",
          optionalPrefix: "X̅",
          tooltip: "",
          currency: true,
          average: true,
          optional: true,
          print_width: "lg",
          cell_width:"xl"
        },

        {
          label: "Precio Trato",
          print: "Precio Trato",
          mobile: "valor/trato",
          value: "precio_trato",
          round: 0,
          prefix: "$",
          totalPrefix: "X̅",
          currency: true,
          tooltip: "",
          optional: true,
          cell_width:"xl"
        },

        {
          label: "Valor trato",
          print: "Valor trato",
          mobile: "Valor trato",
          value: "valor_trato",
          round: 0,
          prefix: " $",
          totalPrefix: "X̅",
          optionalPrefix: "X̅",
          currency: true,
          average: true,
          tooltip: "",
          optional: true,
          print_width: "lg",
          cell_width:"xl"
        },

        {
          label: "Bonos / Jornadas",
          print: "Bonos / Jor",
          mobile: "Bonos Jor",
          value: "bono_jr",
          round: 0,
          prefix: "$",
          totalPrefix: "X̅",
          optionalPrefix: "X̅",
          currency: true,
          average: true,
          tooltip: "",
          print_width: "lg",
          cell_width:"xl"
        },

        {
          label: "Total Horas extras",
          print: "Total Horas extras",
          mobile: "Total Hrs ext.",
          value: "horas_extras",
          totalPrefix: "∑",
          round: 1,
          tooltip: "",
          cell_width:"xl"
        },

        {
          label: "Valor Horas extras",
          print: "Valor Horas extras",
          mobile: "$ Hrs ext.",
          value: "valor_horas_extras",
          totalPrefix: "X̅",
          round: 0,
          prefix: "$",
          currency: true,
          tooltip: "",
          print_width: "lg",
          cell_width:"xl"
        },

        {
          label: "Sem Corrida",
          print: "Sem Corrida",
          mobile: "sem corr",
          value: "semana_corrida",
          prefix: " $",
          totalPrefix: "X̅",
          optionalPrefix: "X̅",
          round: 0,
          currency: true,
          tooltip: "",
          cell_width:"xl"
        },

        {
          label: "Liquido jr",
          print: false, //"Liquido jr",
          mobile: "Liquido jr",
          value: "liquido_jr",
          prefix: " $",
          totalPrefix: "X̅",
          optionalPrefix: "X̅",
          round: 0,
          currency: true,
          average: true,
          tooltip: "",
          cell_width:"xl"
        },

        {
          label: "Liquido",
          print: "Liquido",
          mobile: "Liquido",
          value: "liquido",
          totalPrefix: "∑",
          currency: true,
          prefix: "$",
          round: 0,
          tooltip: "",
          print_width: "lg", // lg, xl, xxl
          cell_width:"xxl"
        }
      ];

      return baseHeaderConfig.flatMap(itemHeader => {
        return arrayData.flatMap((itemData, i) => {
          let sublabel = this.getSearchOptionLabel(itemData.searchOption);
          return {
            ...itemHeader,
            sublabel,
            value : "so_"+i+"."+itemHeader.value
          }
        });
      })
    },

    getSearchOptionLabel(searchOption = null){
      let label = "";
      if(searchOption){
        if(searchOption.optionTimeSelected.var == "mensual"){
          label =searchOption.dates.dateMonthFormated;
        }
        if(searchOption.optionTimeSelected.var == "temporada"){
          label =searchOption.periodoSelected.label;
        }
        if(searchOption.optionTimeSelected.var == "fechas"){
          label =searchOption.dates.dateInicioFormatedReadeable +" - "+searchOption.dates.dateFinFormatedReadeable;
        }

        if(searchOption.filter.dia && searchOption.filter.dia.value > -1){
          label += "("+searchOption.filter.dia.label+")";
        }

        if(searchOption.filter.tipoTrabajador && searchOption.filter.tipoTrabajador.value != "todos"){
          label += "("+searchOption.filter.tipoTrabajador.label+")";
        }
      }


      return label;
    },

    prepareChartTitle() {
      let titleText = this.titleChart;
      let subtitleText = this.subtitlePath.join(" - ");

      if (this.varChartOptionSelected) {
        titleText += " ( " + this.varChartOptionSelected.name + " )";
      }

      if (this.chart) {
        this.chart.update({
          title: {
            text: titleText
          },
          subtitle: {
            text: subtitleText
          }
        });
      } else {
        this.chartOptions.title.text = titleText;
        this.chartOptions.subtitle.text = subtitleText;
      }
    },

    prepareChartEvents() {
      var self = this;
      var lastDrillUpPath = null;
      var lastDrillDownEvent = null;
      this.chartOptions.chart.events = {
        drilldown: function(e) {
          if (e.originalEvent == lastDrillDownEvent) return;
           lastDrillDownEvent= e.originalEvent;
          let name = e.seriesOptions ? e.seriesOptions.pathName: '';
          self.subtitlePath.push(name || "");
          self.prepareChartTitle.bind(self)();
        },
        drillup: function(e) {
          if ( e.seriesOptions._levelNumber == lastDrillUpPath) return;
          lastDrillUpPath = e.seriesOptions._levelNumber;
          self.subtitlePath.pop();
          self.prepareChartTitle.bind(self)();
        }
      };
    },



    prepareChart(arrayData) {
      let drillDrownSeries = [];
      var vars =  this.getTreeVarNames();
      this.chartOptions= _.cloneDeep(HighchartsAnalisis.defaultConfig);

      arrayData.forEach((itemData, itemDataIndex) => {

        let soName = this.getSearchOptionLabel(itemData.searchOption);

        let serie = {
          name: soName,
          pathName: soName,
          //color: "",
          data:[]
        };

        serie.data = (itemData.data[vars[0]] || []).map((item, itemIndex) => {

          let dataDrilldrown = item[vars[1]].map((childItem, childindex) => {
            return {
              id:childItem.nombre+"-ch-"+childindex,
              drilldown:childItem.nombre+"-"+itemDataIndex+"-gch-"+childindex,
              name: childItem.nombre,
              y: _.round(childItem[this.varChartOptionSelected.varName], 2)
            };
          });

          drillDrownSeries.push({
            name: item.nombre+"-"+soName,
            pathName: item.nombre,
            id: item.nombre+"-"+itemDataIndex+"-ch-"+ itemIndex,
            data: dataDrilldrown
          });




          item[vars[1]].forEach((childItem, childindex) => {
            let dataDrilldrown = childItem[vars[2]].map((grandChildItem,grandChildIndex) => {
              return {
                id:grandChildItem.nombre+"-gch-"+grandChildIndex,
                name:grandChildItem.nombre,
                y: _.round(grandChildItem[this.varChartOptionSelected.varName], 2)
              };
            });

            drillDrownSeries.push({
              name:childItem.nombre+"-"+soName,
              pathName:childItem.nombre,
              id:childItem.nombre+"-"+itemDataIndex+"-gch-"+childindex,
              data: dataDrilldrown
            });
          });





          return {
            id: item.nombre+"-"+ itemIndex,
            name: item.nombre,
            drilldown: item.nombre+"-"+itemDataIndex+"-ch-"+ itemIndex,
            //color,
            y: _.round(item[this.varChartOptionSelected.varName], 2)
          }
        });

        this.chartOptions.series.push(serie);

      });

      this.chartOptions.drilldown.series = drillDrownSeries;

      this.prepareChartEvents();

      this.chartKey++;
      this.$nextTick( () =>{
        this.prepareChartTitle();
      });
    },






    dep_prepareChart(dataTable) {

      var seriesData = [];
      var seriesDataComparison = [];
      var drillDrownSeries = [];
      var dataDrilldrown = [];

      this.prepareChartTitle();
      this.prepareChartEvents();

    





      //------------

      _.forEach(dataTable, (data, index) => {

        seriesData.push({
          id: data.label,
          drilldown: data.label + "-ch-" + index,
          color: this.colors.colorReal,
          name: data.label,
          y: _.round(data[this.varChartOptionSelected.varName], 2)
        });

        seriesDataComparison.push({
          id: data.label + "-comparison",
          drilldown: data.label + "-ch-" + index + "-comparison",
          color: this.colors.colorComparison,
          name: data.label,
          y: _.round(data[this.varChartOptionSelected.varName], 2)
        });

        dataDrilldrown = [];
        _.forEach(data.children, (child, indexChild) => {

          var d = {
            id: child.label + "-ch-" + index,
            name: child.label,
            //color: this.colors.colorReal,
            y: _.round(child[this.varChartOptionSelected.varName], 2)
          };
          dataDrilldrown.push(d);

          var dc = {
            id: child.label + "-ch-" + index + "-comparison",
            name: child.label,
            //color: this.colors.colorComparison,
            y: _.round(child[this.varChartOptionSelected.varName], 2)
          };
          dataDrilldrown.push(dc);


          if (child.children) {
            var dataDrilldrown2 = [];

            d.drilldown = child.label + "-ch-" + index + "-ch2-" + indexChild;
            dc.drilldown = child.label + "-ch-" + index + "-ch2-" + indexChild + "-comparison";

            _.forEach(child.children, child2 => {
              var d2 = {
                name: child2.label,
                y: _.round(child2[this.varChartOptionSelected.varName], 2)
              };
              dataDrilldrown2.push(d2);
            });

            drillDrownSeries.push({
              id: child.label + "-ch-" + index + "-ch2-" + indexChild,
              name: child.label,
              color: this.colors.colorReal,
              data: dataDrilldrown2
            });

            drillDrownSeries.push({
              id: child.label + "-ch-" + index + "-ch2-" + indexChild + "-comparison",
              name: child.label,
              color: this.colors.colorComparison,
              data: dataDrilldrown2
            });

          }
        });

        drillDrownSeries.push({
          name: data.label,
          id: data.label + "-ch-" + index,
          data: dataDrilldrown
        });

        drillDrownSeries.push({
          name: data.label,
          id: data.label + "-ch-" + index + "-comparison",
          data: dataDrilldrown
        });

      });

      this.chartOptions.series[0].data = _.cloneDeep(seriesData);
      this.chartOptions.series[1].data = _.cloneDeep(seriesDataComparison);
      this.chartOptions.drilldown.series = drillDrownSeries;
    },






    callbackChart(chart) {
      this.chart = chart;
    },

    moveMonth(searchOption, cant) {
      
      searchOption.dates.dateInicio = searchOption.dates.dateInicio.add(
        cant,
        "month"
      );
      searchOption.dates.dateFin = searchOption.dates.dateFin
        .add(cant, "month")
        .endOf("month");

      searchOption.dates.dateMonth = moment(
        searchOption.dates.dateMonth + "-01",
        "YY-MM-DD"
      )
        .add(cant, "month")
        .format("YY-MM");

      searchOption.dates.dateInicioFormated = searchOption.dates.dateInicio.format(
        "YYYY-MM-DD"
      );
      searchOption.dates.dateFinFormated = searchOption.dates.dateFin.format(
        "YYYY-MM-DD"
      );
      searchOption.dates.dateMonthFormated = moment(
        searchOption.dates.dateMonth + "-01",
        "YY-MM-DD"
      ).format("MMM, YYYY");
    },

    selectPeriodo(searchOption, periodo){
      searchOption.periodoSelected = periodo;
      this.changeOptionTime(searchOption, searchOption.optionTimeSelected);
    },

    selectMonth(searchOption) {
      searchOption.dates.dateInicio = moment(
        searchOption.dates.dateMonth + "-01",
        "YY-MM-DD"
      );
      searchOption.dates.dateFin = moment(
        searchOption.dates.dateMonth + "-01",
        "YY-MM-DD"
      ).endOf("month");
      searchOption.dates.dateInicioFormated = searchOption.dates.dateInicio.format(
        "YYYY-MM-DD"
      );
      searchOption.dates.dateFinFormated = searchOption.dates.dateFin.format(
        "YYYY-MM-DD"
      );
      searchOption.dates.dateMonthFormated = moment(
        searchOption.dates.dateMonth + "-01",
        "YY-MM-DD"
      ).format("MMM, YYYY");
      searchOption.dateMenuMonth = false;
    },

    changeOptionTime(searchOption, item) {
      searchOption.optionTimeSelected = item;
      if (item.var == "mensual") {
        this.selectMonth();
        return;
      } else if (item.var == "temporada") {
        searchOption.dates.dateInicio = moment(
          searchOption.periodoSelected.init,
          "YYYY-MM-DD"
        );
        searchOption.dates.dateFin = moment(
          searchOption.periodoSelected.end,
          "YYYY-MM-DD"
        );
      } else {
        searchOption.dates.dateInicio = new moment();
        searchOption.dates.dateFin = new moment().add(7, "days");
      }
      searchOption.dates.dateInicioFormated = searchOption.dates.dateInicio.format(
        "YYYY-MM-DD"
      );
      searchOption.dates.dateFinFormated = searchOption.dates.dateFin.format(
        "YYYY-MM-DD"
      );
      searchOption.dates.dateInicioFormatedReadeable = searchOption.dates.dateInicio.format(
        "DD MMM YYYY"
      );
      searchOption.dates.dateFinFormatedReadeable = searchOption.dates.dateFin.format(
        "DD MMM YYYY"
      );
    },

    changeDates(searchOption) {
      searchOption.dates.dateInicio = moment(
        searchOption.dates.dateInicioFormated
      );
      searchOption.dates.dateFin = moment(searchOption.dates.dateFinFormated);
      searchOption.dates.dateInicioFormatedReadeable = searchOption.dates.dateInicio.format(
        "DD MMM YYYY"
      );
      searchOption.dates.dateFinFormatedReadeable = searchOption.dates.dateFin.format(
        "DD MMM YYYY"
      );
    },


    clearFilters() {
      this.variablesTable.forEach(v => {
        v.filter.selected = [];
      });
    },
    getBaseData() {
      this.loading = true;
      var promises = [
        this.getCampos(),
        this.getTrabajadores(),
        this.getContratistas(),
        this.getLabores(),
        this.getSubLabores(),
        this.getCentrosCosto()
      ];
      return Promise.all(promises).then(
        () => {
          this.laboresParsed = this.parseLabores();
          this.loading = false;
        },
        resError => {
          console.error(resError);
          this.loading = false;
        }
      );
    },

    getFullTreeName() {
      let tree = [this.v1t.treeName, this.v2t.treeName];
      return tree.join(",");
    },

    getTreeVarNames(){
      return _.flattenDeep([
        this.v1t.varName,
        this.v2t.varName
        //this.v3t.varName
      ]);
    },

    parseLabores() {
      return _.map(this.labores, l => {
        l.subLabores = this.subLabores[l.id];
        return l;
      });
    },

    getCampos() {
      if (this.empresaSelected == null) return;
      return campoModel
        .all({
          params: {
            empresa_id: this.empresaSelected.id
          }
        })
        .then(
          res => {
            this.campos = res.data.data;
            this.camposOptions = _.map(this.campos, c => {
              return {
                val: c,
                label: c.nombre
              };
            });
            this.camposOptions.unshift({
              val: null,
              label: "Todos los Campos"
            });
            this.campoSelected = _.first(this.camposOptions);
          },
          resError => {
            console.error(resError);
          }
        );
    },

    getTrabajadores() {
      if (this.empresaSelected == null) return;
      return trabajadorModel
        .all({
          params: {
            empresa_id: this.empresaSelected.id
          }
        })
        .then(
          res => {
            this.trabajadores = res.data.data;
            _.forEach(this.trabajadores, tr => {
              tr.codname = tr.nombre;
              if (tr.codigo && tr.codigo.length > 1) {
                tr.codname = tr.codigo;
              }
              //this.variablesTable[2].filter.items = this.trabajadores;
            });
          },
          resError => {
            console.error(resError);
          }
        );
    },

    getContratistas() {
      if (this.empresaSelected == null) return;

      return contratistaModel
        .all({
          params: {
            empresa_id: this.empresaSelected.id
          }
        })
        .then(
          res => {
            this.contratistas = res.data.data;
          },
          resError => {
            console.error(resError);
          }
        );
    },

    getLabores() {
      if (this.empresaSelected == null) return;

      return laborModel
        .all({
          params: {
            empresa_id: this.empresaSelected.id
          }
        })
        .then(
          res => {
            this.labores = res.data.data;
            this.variablesTable[0].filter.items = this.labores;
          },
          resError => {
            console.error(resError);
          }
        );
    },

    getSubLabores() {
      if (this.empresaSelected == null) return;

      return subLaborModel
        .all({
          params: {
            empresa_id: this.empresaSelected.id
          }
        })
        .then(
          res => {
            this.subLabores = res.data.data; //_.flatMap(res.data.data, data=>data);
          },
          resError => {
            console.error(resError);
          }
        );
    },

    getCentrosCosto() {
      if (this.empresaSelected == null) return;

      return centrosCostoModel
        .all({
          params: {
            empresa_id: this.empresaSelected.id
          }
        })
        .then(
          res => {
            this.centrosCosto = res.data.data;
            this.variablesTable[1].filter.items = this.centrosCosto;
          },
          resError => {
            console.error(resError);
          }
        );
    },

    verifyVarHeader() {
      return !(
        (this.v1t !== this.v2t && this.v1t !== this.v2t) //&&
        //this.v2t !== this.v3t
      );
    },

    print() {
      var containers = document.getElementsByClassName("container-tl");
      _.forEach(containers, c => {
        c.scrollLeft = 0;
      });
      window.print();
    },

    selectCampo(campo) {
      this.campoSelected = campo;
    },

    alert(text) {
      alert(text);
    },

    /*
    downloadXls() {
      this.$refs["analisisComparativoTable"].downloadXls("Analisis");
    }
    */
  }
};
</script>
<style lang="scss" scoped>
.tag {
  border-radius: 5px;
  background: red;
  margin: 12px 16px;
  padding: 0px 12px;
  font-size: 14px;
  display: inline-block;
  vertical-align: middle;
  border: 1px solid #0d47a1; //900
  background: #42a5f5; // 400
  color: #0d47a1; // 900
  &.tag-print {
    margin: 0px 4px;
  }
}
.header-print {
  margin: 8px 8px 16px 8px;
}
.search-option {
  border-top: 2px solid rgba(0, 0, 0, 0.2);
  border-left: 2px solid rgba(0, 0, 0, 0.2);
  border-right: 2px solid rgba(0, 0, 0, 0.2);

  &:first-child {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }
  &:last-child {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    border-bottom: 2px solid rgba(0, 0, 0, 0.2);
  }
}
</style>
